import axios, { AxiosResponse } from 'axios';

export class MonolithAPI {
  public static async fetchADO() {
    try {
      const response: AxiosResponse<{
        buyer?: {
          id: number;
          first_name: string;
          last_name: string;
          view_access: 'full' | 'view' | 'none';
        };
      }> = await axios.get(`/api/buyers/ado`);

      return response;
    } catch (error) {
      throw error;
    }
  }
}
